/** Order status values (aligned with API); avoid importing from __generated__/graphql here */
const ORDER_STATUS_VALUES = [
  'ABANDONED_CART',
  'APPROVED',
  'ASSIGNED',
  'DECLINED',
  'DELIVERED',
  'DELIVERY_FINISHED',
  'DELIVERY_STARTED',
  'PENDING',
  'PROCESSING',
  'READY',
  'REFUNDED',
  'VOID',
] as const;

export type OrderStatusValue = typeof ORDER_STATUS_VALUES[number];

export type OrderFilterType = 'all' | 'current' | 'completed';

export const ORDER_FILTER_LABELS: Record<OrderFilterType, string> = {
  all: 'All',
  current: 'Current',
  completed: 'Completed',
};

/** Label for mobile trigger when filter is selected (e.g. "All orders" when all) */
export const ORDER_FILTER_MOBILE_LABELS: Record<OrderFilterType, string> = {
  all: 'All orders',
  current: 'Current',
  completed: 'Completed',
};

const COMPLETED_STATUSES: OrderStatusValue[] = [
  'DELIVERED',
  'REFUNDED',
  'VOID',
];

const DECLINED_STATUS: OrderStatusValue = 'DECLINED';

export function isCompletedOrder(
  status: OrderStatusValue | string | null | undefined,
): boolean {
  return !!status && COMPLETED_STATUSES.includes(status as OrderStatusValue);
}

export function isCurrentOrder(
  status: OrderStatusValue | string | null | undefined,
): boolean {
  if (!status) return false;
  return (
    status !== DECLINED_STATUS &&
    !COMPLETED_STATUSES.includes(status as OrderStatusValue)
  );
}

export const ORDER_FILTER_OPTIONS: OrderFilterType[] = [
  'all',
  'current',
  'completed',
];
